import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const PartnerConfigContainer = React.lazy(
  () => import('../../containers/partner-config/partner-config.container')
);

export const PartnerConfigRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <Navigate
        to={
          (APP_ROUTES.PARTNER_CONFIG_MODULE.CHILDREN as RouteConfig).PARTNER_CONFIG_FORM.FULL_PATH
        }
      />
    )
  },
  {
    path: (APP_ROUTES.PARTNER_CONFIG_MODULE.CHILDREN as RouteConfig).PARTNER_CONFIG_FORM.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={PartnerConfigContainer}
        />
      </React.Suspense>
    )
  }
];
